import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LS } from 'src/app/helpers/localStorage.enum';
import { DataService } from 'src/app/services/data/data.service';
import { LocationUIService } from 'src/app/services/location-ui/location-ui.service';
import { LocationService } from 'src/app/services/location/location.service';
import { MapService } from 'src/app/services/map/map.service';
import { SplitViewService } from 'src/app/services/split-view/split-view.service';
import { UserService } from 'src/app/services/user/user.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.sass'],
})
export class ProjectsComponent implements OnInit, AfterViewInit, OnDestroy {
  id;
  currLoc;
  prevLoc;
  ortho;
  threeD;

  currentUser
  permissions

  unsubber: Subject<boolean> = new Subject<boolean>();

  constructor(
    private locationService: LocationService,
    private dataService: DataService,
    private activatedRouter: ActivatedRoute,
    private mapService: MapService,
    private locUIService: LocationUIService,
    private titleService: Title,
    private splitViewService: SplitViewService,
    private locationStore: LocationStoreService,
    private _t: TranslateService,
    private userService: UserService,
  ) { }

  ngAfterViewInit(): void {
    this.activatedRouter.params
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe(
        (params) => {
          this.id = params['id'];
          this.locationStore.setCurrentLocation = {}
          this.currentUserSub()

          if (this.id) {
            this.dataService.featureImages$.next([])
            
            // this.splitViewService.onEvent$.next({ onResetMapLayer: true })
            // setTimeout(() => {
            this.locUIService.refreshCurrLocation(this.id);
            // }, this.mapService.isMapLoaded$.getValue() ? 0 : 1500);
          } else {
            this.locationService
              .findAllParent()
              .pipe(takeUntil(this.unsubber.asObservable()))
              .subscribe((r) => {
                const res = r.data;
                if (res.length > 0) {
                  this.mapService.getLocation(res)
                    .pipe(takeUntil(this.unsubber.asObservable()))
                    .subscribe((location) => {
                      this.mapService.toggleAllAnnotation(false, undefined, undefined);
                      this.dataService.allVisibleMarkers$.next(location)
                      this.mapService.makeMarkers(location);
                    });
                }
              });
          }
        }
      );
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    if (this.id) {
      this.titleService.setTitle('Vertikaliti')
    }

    this.unsubber.next();
    this.unsubber.unsubscribe();
  }

  currentUserSub() {
    this.dataService.localStorageSub$.pipe(takeUntil(this.unsubber.asObservable())).subscribe(res => {
      if (res.key === LS.currentUser) {
        this.currentUser = JSON.parse(res.data);
        this.permissions = this.currentUser.permissions;
      } else {
        this.currentUser = JSON.parse(localStorage.getItem(LS.currentUser));
        this.permissions = this.currentUser.permissions;
      }
    })
    const loadLsLang = () => {
      const lang = localStorage.getItem(LS.defaultLang)
      if (!lang) return
      this._t.use(lang)
    }
    this.userService.getPreference(this.currentUser.user_id).subscribe((preference) => {
      let setLanguage: string = localStorage.getItem(LS.defaultLang);

      if (!preference) {
        loadLsLang()
        return
      }

      const { def_lang } = preference

      if (!def_lang) {
        loadLsLang()
        return
      }
      let changedLang = localStorage.getItem(LS.defaultLang)

      if (!changedLang) {
        setLanguage = changedLang = def_lang
      }
      
      if (changedLang != def_lang){
        setLanguage = def_lang
      }

      localStorage.setItem(LS.defaultLang, setLanguage)
      this._t.use(setLanguage)
    })
  }
}
